<template>
  <v-container class="home" fluid mb-0>
    <v-layout row wrap>
      <span class="bg"></span>
      <v-flex pa-5 xs12 md8 offset-md-2>
        <v-layout row wrap>
          <v-flex pa-5 xs12 md6 v-for="msg in messages" :key="msg.properties.objectid">
            <v-card outline class="mx-auto" min-height="250">
              <v-system-bar color="#8c0d6e" style="padding: 1.2em">
                <v-icon color="#fff">mdi-information-outline</v-icon>
                <span style="color: #fff">
                  {{
                  new Date(msg.properties.lastupdatedatetime).toLocaleString()
                  }}
                </span>
              </v-system-bar>
              <v-card-title class="bw">{{ msg.properties.name }}</v-card-title>
              <v-card-subtitle>
                <table>
                  <tr>
                    <td>Typ zdarzenia:</td>
                    <td class="bw"><v-icon>{{ getIcon(msg.properties.event) }}</v-icon> {{ getType(msg.properties.event) }}</td>
                  </tr>
                  <tr>
                    <td>Rozpoczyna się:</td>
                    <td>{{ new Date(msg.properties.startdatetime).toLocaleString() }}</td>
                  </tr>
                  <tr>
                    <td>Kończy się:</td>
                    <td>
                      {{
                      new Date(msg.properties.enddatetime).toLocaleString()
                      }}
                    </td>
                  </tr>
                </table>
              </v-card-subtitle>
              <v-card-text class="bw">Szczegóły: {{ msg.properties.description }}</v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-btn
                  v-if="msg.properties.web"
                  text
                  :href="msg.properties.web"
                  target="_blank"
                >Szczegóły</v-btn>
                <v-btn
                  v-if="msg.properties.note == 'Tak'"
                  text
                  @click="redirectToMap(msg.geometry.coordinates)"
                >Mapa</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
const Qs = require("qs");

export default {
  name: "messages",
  data() {
    return {
      filterText: "",
      messages: [],
      types: {
        P: { name: "Pożar", selected: true, layer: {}, icon: "/img/stats/ISP.png", 'ico' : "$fire" }, 
        PD: { name: "Prace drogowe", selected: true, layer: {}, icon: "/img/stats/ISPD.png", 'ico' : "$roadwork" },
        BD: { name: "Blokada drogowa", selected: true, layer: {}, icon: "/img/stats/ISBD.png", 'ico' : "$roadblock" },
        Z: { name: "Zgromadzenie", selected: true, layer: {}, icon: "/img/stats/ISZ.png", 'ico' : "$gathering" },
        IM: { name: "Impreza masowa", selected: true, layer: {}, icon: "/img/stats/ISIM.png", 'ico' : "$stage" },
        UR: { name: "Utrudnienia w ruchu", selected: true, layer: {}, icon: "/img/stats/ISUR.png", 'ico' : "$car" },
        W: { name: "Wypadek", selected: true, layer: {}, icon: "/img/stats/ISW.png", 'ico' : "$accident" }
      }
    };
  },
  mounted() {
    var rfilter = decodeURI(this.$route.params.filter);
    console.log("RFILTER: "+rfilter);
    this.filterText = this.$store.state.filterValue;
    this.loadData();
    this.$store.subscribe((mutation, state) => {
      if (mutation.type == "SET_FILTER") {
        this.filterText = state.filterValue;
        this.loadData();
      }
    });
  },
  methods: {
    redirectToMap(coord) {
      var scords = encodeURI(coord);
      this.$router.push({
        name: "stats",
        params: { scords: scords }
      });
    },
    getType(event) {
      if(this.types[event])
        return this.types[event].name;
      return "";
    },
    getIcon(event) {
      if(this.types[event])
        return this.types[event].ico;
      return "";
    },
    loadData() {
      var dateobj = new Date();
      //this.filterText = decodeURI(this.$route.params.filter);
      //var newdate = new Date();
      //newdate.setDate(dateobj.getDate() - 79);
      //var todayISO = newdate.toISOString();
      //      console.log(todayISO);
      var constraints = [];
      var todayISO = dateobj.toISOString();
      if (this.$store.state.currentEvents && this.$store.state.futureEvents)
        constraints.push("enddatetime+gte+" + todayISO);
      if (this.$store.state.currentEvents && !this.$store.state.futureEvents) {
        constraints.push("startdatetime+lte+" + todayISO);
        constraints.push("enddatetime+gte+" + todayISO);
      }
      if (!this.$store.state.currentEvents && this.$store.state.futureEvents) {
        constraints.push("startdatetime+gte+" + todayISO);
        constraints.push("enddatetime+gte+" + todayISO);
      }
      if (!this.$store.state.currentEvents && !this.$store.state.futureEvents) {
        constraints.push("startdatetime+gt+" + todayISO);
        constraints.push("enddatetime+lt+" + todayISO);
      }
      if (this.filterText != "") {
        var decfilter = decodeURI(this.filterText);
        constraints.push("LOWER(name||description)+like+" + decfilter.toLowerCase() );
      }
      // "enddatetime+gte+" + todayISO,
      // "startdatetime+gte+" + todayISO,
      // "event+neq+UR",
      // "name+like+%s%"
      console.log("params: " + this.filterText);
      axios
        .get("/IOCNext/api/spatial/static_information", {
          params: {
            criterion: constraints,
            sort: ["startdatetime+desc", "enddatetime+desc"]
          },
          paramsSerializer: function(params) {
            return Qs.stringify(params, { arrayFormat: "repeat" });
          }
        })
        .then(response => {
          console.log("++++readed objects");
          console.log(response);
          this.messages = response.data.features;
        })
        .catch(error => console.log(error));
    }
  }
};
</script>
<style>
.home {
  margin-top: 16em;
}
.bg {
  width: 100%;
  height: 20em;
  position: absolute;
  top: 0;
  left: 0;
  background: url("/img/katowice2.jpg") no-repeat center center;
  background-size: cover;
  transform: scale(1.1);
}

.bw {
-ms-word-break: break-all;
-ms-word-wrap: break-all;
-webkit-word-break: break-word;
-webkit-word-wrap: break-word;
word-break: break-word;
word-wrap: break-word;
-webkit-hyphens: auto;
-moz-hyphens: auto;
hyphens: auto;
}
</style>
